import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, MessageCircle, Send } from "lucide-react";
import { PublicLayout } from "../components/Common";
import api from "../lib/api";

export default function Contact() {
  const [settings, setSettings] = useState({});
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  useEffect(() => {
    document.title = "Kontak - DS KODE";
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact-messages", form);
      toast.success("Pesan Anda telah terkirim. Kami akan segera menghubungi Anda.");
      setForm({ name: "", email: "", message: "" });
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Pesan gagal dikirim.");
    }
  };
  return (
    <PublicLayout>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-2 gap-8">
        <div>
          <h1 className="font-heading text-3xl font-extrabold text-slate-900">Hubungi Kami</h1>
          <p className="text-slate-500 mt-2 mb-6">Ada pertanyaan? Kirim pesan atau hubungi kami langsung.</p>
          <div className="space-y-3">
            <div className="flex items-center gap-3 bg-white rounded-xl border border-slate-200 p-4">
              <span className="grid place-items-center h-10 w-10 rounded-lg bg-indigo-50 text-indigo-600"><Mail className="h-5 w-5" /></span>
              <div><p className="text-xs text-slate-500">Email</p><p className="font-medium text-slate-900">{settings.contact_email || "support@dskode.id"}</p></div>
            </div>
            <div className="flex items-center gap-3 bg-white rounded-xl border border-slate-200 p-4">
              <span className="grid place-items-center h-10 w-10 rounded-lg bg-emerald-50 text-emerald-600"><MessageCircle className="h-5 w-5" /></span>
              <div><p className="text-xs text-slate-500">WhatsApp</p><p className="font-medium text-slate-900">{settings.contact_whatsapp || "+62 812-0000-0000"}</p></div>
            </div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-xl border border-slate-200 p-6 space-y-4">
          <div><label className="text-sm font-medium text-slate-700">Nama</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:ring-2 focus:ring-indigo-500 focus:outline-none" data-testid="contact-name" /></div>
          <div><label className="text-sm font-medium text-slate-700">Email</label><input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:ring-2 focus:ring-indigo-500 focus:outline-none" data-testid="contact-email" /></div>
          <div><label className="text-sm font-medium text-slate-700">Pesan</label><textarea required rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:ring-2 focus:ring-indigo-500 focus:outline-none" data-testid="contact-message" /></div>
          <button type="submit" data-testid="contact-submit" className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors"><Send className="h-4 w-4" /> Kirim Pesan</button>
        </form>
      </div>
    </PublicLayout>
  );
}
